import React, {useState, useEffect} from "react";
import {useHistory} from 'react-router-dom';
import moment from 'moment';
import {Box, Button, FormControl, List, ListItem, ListItemIcon, ListItemText, Typography} from '@mui/material';
import {Circle, ExpandLessRounded, ExpandMoreRounded} from '@mui/icons-material';
import {useTranslation} from 'react-i18next';
import ButtonComponent from '../components/ButtonComponent';
import CircularProgressLoader from '../components/CircularProgressLoader';
import {BUTTON_PRIMARY, BUTTON_WARNING, SUCCESS, ERROR, TOAST_ERROR} from '../assets/constants/Constants';
import {LoptopIcon, LuggageIcon, OfficeBegIcon, RADIO_CHECKED_ICON, RADIO_UNCHECKED_ICON, SchoolBegIcon, bestIcpon} from '../assets/constants/Icons';
import {BOOKING_SUMMARY, CANCEL_OR_ERROR_PAGE, HOME, LOCKER_SIZE_SELECTION, LOCKER_UNIT_SELECTION, LOGIN, OPEN_LOCKER, PARCEL_OWNER, PAYMENT_GATEWAY, SUCCESS_PAGE, SWIPE_TO_OPEN_LOCKER} from '../assets/constants/PageList';
import {LOCAL_STORAGE, SESSION_STORAGE, LS_LOCKER_BANK_INFO, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS, SS_PAYMENT_GATEWAY, SS_PAYMENT_GATEWAY_ACCESS_KEY, PAYMENT_REFERENCE_ID, LS_IS_REDIRECTED_FROM_STRIPE_PAYMENT_GATEWAY, LS_PROP_LOCKER_UNIT_DETAILS, IS_LOGGED_IN, LS_DOMAIN_AND_LOCKER_BANK} from '../assets/constants/BrowserStorageKeys';
import {getSecureItemFromSpecificStorage, storeSecureItemInSpecifiedStorage} from '../lib/BrowserStorageAccessMiddleware';
import {buildBulkPaymentInitial, bulkLockerReserver, getTenantAndAssignmentSettings, reserveLocker} from '../api/api';
import {prePaymentRegistration} from '../lib/BackendUtils';
import {getPathForNextPage, convertDurationStringToMilliseconds, verifyUserProximity, toFeetInches, checkIfAssignmentIsProperlyConfigured, applyBackendLanguageConfig, getPriceBySizeFor24Hr, getPriceFor24Hr, getSlotIdFor24Hourse, findMatchingSlotByDuration, generateReserveTiming, getRoundedDurationInHours, getPriceForSelectedTiming, handleBulkReservationPayment, getRoundedDurationInDays, getCurrencySymbol} from '../lib/Utils';
import CustomDialog from '../components/CustomDialog';
import ShowToast from '../components/ToastComponent';
import { ReactComponent as DuroltLogoIcon } from "../assets/images/durolt_logo_new.svg";
import LockerIcon from '../assets/locker.svg';
import LockerDurationDialog from "../components/LockerDurationDialog";
import LockerModalContent from "../components/LockerBookingSlotComponent";

const LockerSizePage = () => {
    const history = useHistory();
    const {t} = useTranslation();
    const lockerBankInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_LOCKER_BANK_INFO);
    const tenantAndAssignmentSettings = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS);
    const [isLoading, setIsLoading] = useState(true);
    const [loadingMessage, setLoadingMessage] = useState(t('Loading'));
    const [showBookingConfirmationModal, setBookingConfirmationModalVisibility] = useState(false);
    const state = history.location?.state || {};
    const {
    lockerBankId,
    assignmentSlug,
    userId,
    availableLockerSizes = [],
    IsAdvanceBooking = false,
    address = "puna lulla nagar",
    bookingTimingObject = [],
    locker_bank_slug,
    isManualLockerSelectionEnabled,
    lockerCurrency = 'null',
    selectedLockers: preselectedLockers = []
    } = state;
console.log("IsAdvanceBooking value is :", IsAdvanceBooking);
    // const { lockerBankId, assignmentSlug, userId, availableLockerSizes, isManualLockerSelectionEnabled, IsAdvanceBooking = false, address="puna lulla nagar" , 
    //     bookingTimingObject=[{}] , locker_bank_slug
    //  } = history.location?.state;

    const isPricingEnabled = tenantAndAssignmentSettings?.is_pricing;
    const isParcelDropUser = tenantAndAssignmentSettings?.usecase_settings?.show_drop_btn_pwa?.value;
    const [selectedSizeId, setSelectedSizeId] = useState(null);
    const [selectedSlotId, setSelectedSlotId] = useState(null);
    const [showBookingSlots, setShowBookingSlots] = useState(false);
    const [userProximityError, setUserProximityError] = useState('');
    const [isUserProximityErrorModalVisible, setIsUserProximityErrorModalVisible] = useState(false);
    const [showBookingInstructionModal, setShowBookingInstructionModal] = useState(isPricingEnabled);
    const [lockerQty, setLockerQty] = useState({});
    const [selectedLockers, setSelectedLockers] = useState(preselectedLockers || []);
    const[showSlotDurationDailog, setShowSlotDurationDailog] = useState(false);
   // const [selectedBookingSlot, setSelectedBookingSlot] = useState([]);
    const [selectedBookingSlot, setSelectedBookingSlot] = useState(null);

    const [selectedSlotData, setSelectedSlotData] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showBulkSlotModal, setShowBulkSlotModal] = useState(false);
    const [bulkSelectedDuration, setBulkSelectedDuration] = useState(null);
    console.log("availableLockerSizes in locker size page :",availableLockerSizes , 
        " IsAdvanceBooking: ", IsAdvanceBooking , " bookingTimingObject: ",bookingTimingObject);
        console.log("availableLockerSizes : ", availableLockerSizes);
        
    useEffect(() => {
        if (isPricingEnabled && !IsAdvanceBooking ) {
            sortAndFormatSlotDuration();
        }
        setIsLoading(false);
    }, []);

    useEffect(() => {
        console.log("showSlotDurationDailog updated:", showSlotDurationDailog);
    }, [showSlotDurationDailog]);

    const increaseQty = (locker, price24h) => {
        console.log("locker for increse is:", locker);
    if (!IsAdvanceBooking && locker?.bookingSlots && locker?.size_pricing) {
        // setSelectedBookingSlot(locker.bookingSlots);
        // setShowSlotDurationDailog(true);
         setSelectedLockers((prev) => {
        const count = prev.filter(
        (item) => item.door_size === locker.code
        ).length;

        if (count >= locker.available_doors_count) return prev;

        return [
        ...prev,
        {
            door_size: locker.code,
            name: `${locker.name} Locker`,
            bookingSlots:locker?.bookingSlots,
            currency:locker?.currency
        },
        ];
    });
        
    }else{
    setSelectedLockers((prev) => {
        console.log("reser timing is :",bookingTimingObject);
        const count = prev.filter(
        (item) => item.door_size === locker.code
        ).length;

        if (count >= locker.available_doors_count) return prev;

        return [
        ...prev,
        {
            door_size: locker.code,
            price: IsAdvanceBooking ? 
            getPriceForSelectedTiming(getRoundedDurationInHours(bookingTimingObject?.reserve_start , bookingTimingObject?.reserve_end ),price24h) : 0,
            durations: [
            {
                label: `${getRoundedDurationInDays(bookingTimingObject?.reserve_start , bookingTimingObject?.reserve_end )} days`,
                price: IsAdvanceBooking ? getPriceForSelectedTiming(getRoundedDurationInHours(bookingTimingObject?.reserve_start , bookingTimingObject?.reserve_end ),price24h) : 0,
            },
            ],
            name: `${locker.name} Locker`,
            slot_id: getSlotIdFor24Hourse(locker?.size_pricing)
        },
        ];
    });
    };}

    const decreaseQty = (locker) => {
    if (!IsAdvanceBooking && locker?.bookingSlots) {
        // setSelectedBookingSlot(locker.bookingSlots);
        // setShowSlotDurationDailog(true);
    }

    setSelectedLockers((prev) => {
        const index = prev.findIndex(
        (item) => item.door_size === locker.code
        );

        if (index === -1) return prev;

        const newArray = [...prev];
        newArray.splice(index, 1);

        return newArray;
    });
    };


const totalPrice = selectedLockers.reduce((sum, locker) => {
    return sum + locker.price;
}, 0);

const handleLockerBooking = async (lockers = null, total = null) => {
  const finalLockers = lockers || selectedLockers;
  const finalTotal = total ?? totalPrice;


  console.log("selected locker is : ", finalLockers);

  // ✅ FIX: define outside
  let allocationData = [];

  if (finalLockers[0]?.selectedSlot && finalLockers[0]?.bookingSlots) {
    console.log("finalLockers?.selectedSlot:");
    // Case: coming from BookingSummary (with selectedSlot)
    allocationData = finalLockers.map((locker) => ({
      door_size: locker.door_size,
      price: Number(locker?.selectedSlot?.price || 0),
      slot_id: locker?.selectedSlot?.id || null,
    }));
  } else {
    console.log("finalLockers:",finalLockers)
    // Case: normal flow (already has price + slot_id)
    allocationData = finalLockers.map((locker) => ({
      door_size: locker.door_size,
      price: Number(locker.price || 0),
      slot_id: locker.slot_id || null,
    }));
  }

  // ✅ Timing fallback
  const timingData =
    bookingTimingObject && Object.keys(bookingTimingObject).length > 0
      ? bookingTimingObject
      : generateReserveTiming(6);

  console.log("timingData: ", timingData);

  const bookingObject = {
    ...timingData,
    allocation_method: "automatic_allocation",
    allocation_data: allocationData,
    total_price: finalTotal,
    locker_bank_id: lockerBankId,
    locker_bank_slug: locker_bank_slug
      ? locker_bank_slug
      : getSecureItemFromSpecificStorage(LOCAL_STORAGE, "locker_slug"),
    assignmentSlug: assignmentSlug,
  };

  console.log("handleLockerBooking object : ", bookingObject);

      if(IsAdvanceBooking){
        // redirect to login page before redirect to login page set the valid assignment setting to application 
        // so user can login and process further 
         history.push({
                    pathname: getPathForNextPage(LOCKER_SIZE_SELECTION, LOGIN),
                    state: {
                        bookingObject: bookingObject
                    }
                });
    }else{
        // make payment process as normal flow
        console.log("have to call reserver call and paymnt");
        const reserveLockerResponse = await bulkLockerReserver(bookingObject);
        console.log("responseReserveBuik: ", reserveLockerResponse);
        // if(reserveLockerResponse.data?.status === 'success'){
        //     const object = {
        //                       "payment_gateway": reserveLockerResponse?.data?.data?.assignment_payment_gateway?.payment_gateway,
        //                       "booking_id": reserveLockerResponse?.data?.data?.ref_id,
        //                       "locker_bank_id": reserveLockerResponse?.data?.data?.locker_bank?.id,
        //                       "amount": reserveLockerResponse?.data?.data?.amount,
        //                       "accept_payment_mode": "default"
        //                     }
        //                     // initial payent call api then lunch the payment
        //                     console.log(" payment object is :", object); 
        //                     const prepaymentResponse = await buildBulkPaymentInitial(object);
        //                     console.log("payment response is :", prepaymentResponse);
        //                     if(reserveLockerResponse?.data?.status == "success"){
        //                       //redirect to payment page with payload 
        //                       const temp = reserveLockerResponse?.data?.data;
        //                       const lockerUnitDetails = {
        //                         ref_id: temp?.ref_id,
        //                         is_already_opened_once: false,
        //                         locker_bank: {
        //                             name: temp?.locker_bank_name
        //                         },
        //                         locker_door: {
        //                             door_no: temp?.door_no
        //                         }
        //                     };
            
        //                     const lockerData = {
        //                           reservedLocker: temp,
        //                           locker_bank: {
        //                               name: temp?.locker_bank_name,
        //                               location: {
        //                                   name: temp?.locker_bank_location
        //                               }
        //                           },
        //                           assignment: {
        //                               payment_gateway: [ temp?.assignment_payment_gateway ]
        //                           },
        //                           payment_records: [
        //                               { amount: prepaymentResponse?.data?.data?.amount }
        //                           ],
        //                           user: {
        //                               username:  prepaymentResponse?.data?.data?.user?.username,
        //                               email: prepaymentResponse?.data?.data?.user?.email,
        //                               mobile_number: prepaymentResponse?.data?.data?.user?.mobile_number
        //                           }
        //                       };
        //                       storeSecureItemInSpecifiedStorage(SESSION_STORAGE, SS_PAYMENT_GATEWAY, temp?.assignment_payment_gateway?.payment_gateway);
        //                       storeSecureItemInSpecifiedStorage(SESSION_STORAGE, SS_PAYMENT_GATEWAY_ACCESS_KEY, prepaymentResponse?.data?.data?.order_id);
        //                       history.replace({
        //                           pathname: '/payment-details',
        //                           state: {
        //                               lockerUnitDetails,
        //                               isLockerReservedTillSuccessfulPayment: true,
        //                               lockerData,
        //                               // paymentGateway: prePaymentResponse?.data?.data?.payment_gateway,
        //                               currentReferenceId: prepaymentResponse?.data?.data?.order_id,
        //                               // paymentGatewayAccessKey: prePaymentResponse?.data?.data?.payment_gateway_reference
        //                           }
        //                       });
        //                     }
        // }
        await handleBulkReservationPayment(reserveLockerResponse, history, { isAdvanceBooking: IsAdvanceBooking });
    }
};


    console.log("lockerBankId: ", lockerBankId , "assignmentSlug: ", assignmentSlug , "userId: ", userId , "availableLockerSizes: ",availableLockerSizes,
        "isManualLockerSelectionEnabled: ", isManualLockerSelectionEnabled ,  "IsAdvanceBooking: ",IsAdvanceBooking);
    // avaid this below funtion for advance booking
    const sortAndFormatSlotDuration = () => {
        availableLockerSizes.forEach((lockerSize) => {
            lockerSize.dimensions = `${parseFloat(lockerSize.width)}\" x ${parseFloat(lockerSize.length)}\" x ${parseFloat(lockerSize.height)}\"`;

            lockerSize.size_pricing.forEach((slot) => {
                slot.durationInMilliseconds = convertDurationStringToMilliseconds(slot.duration);
            });

            const incrementallySortedBookingSlots = sortBookingSlotsBasedOnDuration(lockerSize.size_pricing);

            let previousDurationInMilliseconds = 0;
            incrementallySortedBookingSlots.forEach((slot) => {
                slot.durationRange = `${previousDurationInMilliseconds / 3600000} - ${slot.durationInMilliseconds / 3600000} Hours`;
                previousDurationInMilliseconds = slot.durationInMilliseconds;
            });

            lockerSize.bookingSlots = incrementallySortedBookingSlots;
        });
    };
    // avaid this below funtion for advance booking
    const sortBookingSlotsBasedOnDuration = (slotsArray) => {
        return slotsArray.slice().sort((a, b) => a.durationInMilliseconds - b.durationInMilliseconds);
    };

    const lockerSizeClickHandler = (item) => {
        // if (isPricingEnabled) {
        //     console.log("gsdgdsgsg")
        //     setSelectedSizeId(item.id);
        //     setSelectedSlotId(item.bookingSlots[0].id);
        //     setShowBookingSlots(true);
        // }
        if (isParcelDropUser) {
            history.replace({
                pathname:getPathForNextPage(LOCKER_SIZE_SELECTION, PARCEL_OWNER),
                state: {
                    lockerSize: item.code,
                    lockerItem:item,
                }
            })            
        }
        else {
            lockerSizeSelectionHandler(item);
        }
    }

    
     // avaid this below funtion for advance booking
    const lockerSizeSelectionHandler = async (item) => {
        if (isManualLockerSelectionEnabled) {
            history.replace({
                pathname: getPathForNextPage(LOCKER_SIZE_SELECTION, LOCKER_UNIT_SELECTION),
                state: {
                    lockerBankId,
                    assignmentSlug,
                    userId,
                    selectedLockerSize: item
                }
            });
        }
        else {
            setIsLoading(true);
            try {
                if (tenantAndAssignmentSettings?.is_geofencing) {
                    const lockerBankLatitude = lockerBankInfo?.latitude ? parseFloat(lockerBankInfo?.latitude) : null;
                    const lockerBankLongitude = lockerBankInfo?.longitude ? parseFloat(lockerBankInfo?.longitude) : null;
                    const maxAllowedDistanceInMeters = tenantAndAssignmentSettings?.geofencing_radius;
                    const isUserNearbyLockerBank = await verifyUserProximity({latitude: lockerBankLatitude, longitude: lockerBankLongitude}, maxAllowedDistanceInMeters);
                    
                    if ( !isUserNearbyLockerBank.isNearby ) {
                        setLoadingMessage('');
                        setIsLoading(false);
                        setUserProximityError(isUserNearbyLockerBank.message);
                        setIsUserProximityErrorModalVisible(true);
        
                        return;
                    }
                }

                const reserveLockerResponse = await reserveLocker(assignmentSlug, lockerBankId, userId, item.code);
                if (reserveLockerResponse.status === SUCCESS) {
                    const lockerUnitDetails = {
                        ref_id: reserveLockerResponse?.data?.transaction_id,
                        is_already_opened_once: false,
                        locker_bank: {
                            name: reserveLockerResponse?.data?.locker_bank_name
                        },
                        locker_door: {
                            door_no: reserveLockerResponse?.data?.door_no
                        }
                    };

                    history.replace({
                        pathname: getPathForNextPage(LOCKER_SIZE_SELECTION, OPEN_LOCKER),
                        state: {
                            lockerUnitDetails
                            // assignedLocker: response.data
                        }
                    });
                }
            } catch (error) {
                setIsLoading(false);
                console.error('Error while reserving locker: ', error);
            }
        }
    };

    // should for advance booking
    const bookButtonHandler = async () => {
        setLoadingMessage(t('initiating_transaction_please_wait'));
        setIsLoading(true);

        if (tenantAndAssignmentSettings?.is_geofencing) {
            const lockerBankLatitude = lockerBankInfo?.latitude ? parseFloat(lockerBankInfo?.latitude) : null;
            const lockerBankLongitude = lockerBankInfo?.longitude ? parseFloat(lockerBankInfo?.longitude) : null;
            const maxAllowedDistanceInMeters = tenantAndAssignmentSettings?.geofencing_radius;
            const isUserNearbyLockerBank = await verifyUserProximity({latitude: lockerBankLatitude, longitude: lockerBankLongitude}, maxAllowedDistanceInMeters);
            
            if ( !isUserNearbyLockerBank.isNearby ) {
                setLoadingMessage('');
                setIsLoading(false);
                setUserProximityError(isUserNearbyLockerBank.message);
                setIsUserProximityErrorModalVisible(true);

                return;
            }
        }

        const selectedSize = availableLockerSizes.filter((lockerSize) => selectedSizeId === lockerSize?.id)[0];
        const selectedSlot = selectedSize?.size_pricing.filter((slot) => selectedSlotId === slot?.id)[0];

        const reserveLockerResponse = await reserveLockerTillSuccessfulPayment(selectedSize, selectedSlot);
        
        if (reserveLockerResponse?.status === SUCCESS) {
            const prePaymentResponse = await makePrePaymentRegistration(reserveLockerResponse.data);
            console.log('pre payment response: ', prePaymentResponse);

            if (prePaymentResponse?.status === SUCCESS) {
                // if (prePaymentResponse?.data?.data?.payment_gateway === 'stripe') {
                //     storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, 'isRedirectedFromStripePG', true);
                //     storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, PAYMENT_REFERENCE_ID, reserveLockerResponse?.data?.transaction_payments[0]?.transaction_id);

                //     window.location.href = prePaymentResponse?.data?.data?.field_1;
                // }

                const lockerUnitDetails = {
                    ref_id: reserveLockerResponse?.data?.transaction_id,
                    is_already_opened_once: false,
                    locker_bank: {
                        name: reserveLockerResponse?.data?.locker_bank_name
                    },
                    locker_door: {
                        door_no: reserveLockerResponse?.data?.door_no
                    }
                };

                if (prePaymentResponse?.data?.data?.payment_gateway === 'stripe') {
                    lockerUnitDetails.payment_records = [
                        {
                            payment_gateway: prePaymentResponse?.data?.data?.payment_gateway,
                            payment_gateway_reference: prePaymentResponse?.data?.data?.payment_id,
                            transaction_id: prePaymentResponse?.data?.data?.transaction_id
                        }
                    ];
                    console.log('locker unit details: ', lockerUnitDetails);
                    storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, LS_IS_REDIRECTED_FROM_STRIPE_PAYMENT_GATEWAY, true);
                    storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, LS_PROP_LOCKER_UNIT_DETAILS, lockerUnitDetails);

                    window.location.href = prePaymentResponse?.data?.data?.field_1;
                    return;
                }

                const lockerData = {
                    reservedLocker: reserveLockerResponse?.data,
                    locker_bank: {
                        name: reserveLockerResponse?.data?.locker_bank_name,
                        location: {
                            name: reserveLockerResponse?.data?.locker_bank_location
                        }
                    },
                    assignment: {
                        payment_gateway: [ reserveLockerResponse?.data?.assignment_payment_gateway ]
                    },
                    payment_records: [
                        { amount: prePaymentResponse?.data?.data?.amount }
                    ],
                    user: {
                        username: reserveLockerResponse?.data?.username ? reserveLockerResponse?.data?.username : "",
                        email: reserveLockerResponse?.data?.transaction_payments[0]?.user_email ? reserveLockerResponse?.data?.transaction_payments[0].user_email : "",
                        mobile_number: reserveLockerResponse?.data?.transaction_payments[0]?.user_mobile ? reserveLockerResponse?.data?.transaction_payments[0].user_mobile : ""
                    }
                };
                storeSecureItemInSpecifiedStorage(SESSION_STORAGE, SS_PAYMENT_GATEWAY, prePaymentResponse?.data?.data?.payment_gateway);
                storeSecureItemInSpecifiedStorage(SESSION_STORAGE, SS_PAYMENT_GATEWAY_ACCESS_KEY, prePaymentResponse?.data?.data?.payment_gateway_reference);

                setIsLoading(false);
                // return;

                history.replace({
                    pathname: getPathForNextPage(LOCKER_SIZE_SELECTION, PAYMENT_GATEWAY),
                    state: {
                        lockerUnitDetails,
                        isLockerReservedTillSuccessfulPayment: true,
                        lockerData,
                        // paymentGateway: prePaymentResponse?.data?.data?.payment_gateway,
                        currentReferenceId: prePaymentResponse?.data?.data?.transaction_id,
                        // paymentGatewayAccessKey: prePaymentResponse?.data?.data?.payment_gateway_reference
                    }
                });
            }
            else if (prePaymentResponse.status === ERROR) {
                ShowToast(t(prePaymentResponse.message), TOAST_ERROR);
            }
        }

        setIsLoading(false);
    };

    const reserveLockerTillSuccessfulPayment = async (selectedSize, selectedSlot) => {
        try {
            return await reserveLocker(assignmentSlug, lockerBankId, userId, selectedSize?.code, null, selectedSlot?.id, parseFloat(selectedSlot?.price));
        } catch (error) {
            console.error('Error while reserving locker before payment: ', error);
        }
    };

    // should for advance booking
    const makePrePaymentRegistration = async (lockerData) => {
        try {
            const body = {
                "payment_reference_id": lockerData?.transaction_payments[0]?.transaction_id,
                "payment_gateway": lockerData?.transaction_payments[0]?.payment_gateway,
                "locker_bank_id": lockerBankId,
                "locker_door_number": lockerData?.door_no,
                "amount": lockerData?.transaction_payments[0]?.amount,
                "currency": lockerData?.transaction_payments[0]?.currency,
                "payment_mode": lockerData?.transaction_payments[0]?.payment_mode
            };

            if (lockerData?.transaction_payments[0]?.payment_gateway === 'stripe') {
                body.success_url = `${window.location.protocol}//${window.location.host}${getPathForNextPage(PAYMENT_GATEWAY, SUCCESS_PAGE)}`;
                body.cancel_url = `${window.location.protocol}//${window.location.host}${getPathForNextPage(PAYMENT_GATEWAY, CANCEL_OR_ERROR_PAGE)}`;
            }

            return await prePaymentRegistration(body);
        } catch (error) {
            console.error('Error while initating payment: ', error);
        }
    };

    //  should for avoid advance booking
    const renderBookingConfirmationModalContent = () => {
        const selectedSize = availableLockerSizes.filter((lockerSize) => selectedSizeId === lockerSize?.id)[0];
        const selectedSlot = selectedSize?.bookingSlots.filter((slot) => selectedSlotId === slot?.id)[0];
        const bookingStartDateAndTime = moment().format('DD MMM YYYY, hh:mm A');
        const bookingEndDateAndTime = moment().add(selectedSlot?.durationInMilliseconds, 'milliseconds').format('DD MMM YYYY, hh:mm A');

        return (
            <Box className='modal-content'>
                    <Box className='booking-details'>
                    <Box className='info-row'>
                        <Typography className='left-column'>{t('slot_label')}</Typography>
                        <Typography className='right-column'>{selectedSlot?.durationRange}</Typography>
                    </Box>
                    <Box className='info-row'>
                        <Typography className='left-column'>{t('start_date_time_label')}</Typography>
                        <Box>
                            <Typography className='right-column'>{bookingStartDateAndTime.split(',')[1]}</Typography>
                            <Typography className='right-column'>{bookingStartDateAndTime.split(',')[0]}</Typography>
                        </Box>
                    </Box>
                    <Box className='info-row'>
                        <Typography className='left-column'>{t('end_date_time_label')}</Typography>
                        <Box>
                            <Typography className='right-column'>{bookingEndDateAndTime.split(',')[1]}</Typography>
                            <Typography className='right-column'>{bookingEndDateAndTime.split(',')[0]}</Typography>
                        </Box>
                    </Box>
                    <Box className='info-row'>
                        <Typography className='left-column'>{t('price_with_currency_label', { currency: selectedSize?.currency })}</Typography>
                        <Typography className='right-column'>{selectedSlot?.price}</Typography>
                    </Box>
                </Box>
            </Box>
        );
    };

    const renderBookingInstructionsModalContent = () => {
        return (
            <div className="booking-instructions">
                <ol className="instructions-list list-decimal">
                    <li>{t('luggageLockerInstructionsPoint1')}</li>
                    <li>{t('luggageLockerInstructionsPoint2')}</li>
                    <li>{t('luggageLockerInstructionsPoint3')}</li>
                    <li>{t('luggageLockerInstructionsPoint4')}</li>
                    <li>{t('luggageLockerInstructionsPoint5')}</li>
                    <li>{t('luggageLockerInstructionsPoint6')}</li>
                    <li>{t('luggageLockerInstructionsPoint7')}</li>
                </ol>
            </div>
        );
    }
    const convertTOInch = (widths,depths, heights)=>{
        const width = toFeetInches(widths);
        const depth = toFeetInches(depths);
        const height = toFeetInches(heights);
        const finalDim = `${width} W x ${depth} D x ${height} H`;
        return finalDim;
    }

    const goToBookingSummary = (lockersOverride = null) => {
        const lockersToSend = lockersOverride || selectedLockers;
        history.push({
            pathname: getPathForNextPage(LOCKER_SIZE_SELECTION, BOOKING_SUMMARY),
            state: {
                ...state,
                lockerBankId,
                assignmentSlug,
                address,
                bookingTimingObject,
                locker_bank_slug,
                isManualLockerSelectionEnabled,
                IsAdvanceBooking,
                lockerCurrency,
                selectedLockers: lockersToSend
            }
        });
    };

    const handleSelectedLokcerObject = ()=>{
            // check for advance-booking or normal bulk booking
             console.log("selectedLockers:", selectedLockers);
             console.log("for model ",selectedLockers[0]?.bookingSlots)
            if(isPricingEnabled && IsAdvanceBooking){
                goToBookingSummary();
            }else if(isPricingEnabled && !IsAdvanceBooking){
                // show slot selection modal for normal booking (bulk)
                if (selectedLockers?.length && selectedLockers[0]?.bookingSlots?.length) {
                    setShowBulkSlotModal(true);
                } else {
                    goToBookingSummary();
                }
            }
    }

    const handleLockerSelectionForSlot = (locker)=>{
        console.log("selected locker data is: ", locker);
        // setSelectedBookingSlot((prev) => [...prev, locker]);
        setSelectedBookingSlot(locker);
        setIsModalOpen(true)
    }

       const handleSlotSelectedLockers = () => {
        console.log("calling with selectedBookingSlot:", selectedBookingSlot, 
            " and selectedSlotId : ", selectedSlotId
        );
        
        // Get the selected slot from the modal using the tracked ID
        const selectedSlot = selectedBookingSlot?.bookingSlots?.find(
            slot => slot.id === selectedSlotId
        );
        
        console.log("selectedSlot: ", selectedSlot);
        
        if (!selectedSlot) {
            console.error("No slot selected");
            return;
        }
        
        const targetDuration = selectedSlot.durationInMilliseconds;
        
        // Map through all selected lockers and find matching slot for each
        const updatedLockers = selectedLockers.map(locker => {
            const matchingSlot = findMatchingSlotByDuration(locker, targetDuration);
            
            return {
                ...locker,
                selectedSlot: matchingSlot,
                selectedSlotId: matchingSlot?.id || null,
                selectedPrice: matchingSlot?.price || null,
                selectedDuration: matchingSlot?.duration || null
            };
        });
        
        // Update state with the new lockers data
        setSelectedLockers(updatedLockers);
        console.log("updatedLockers", updatedLockers);
        
        // Now you can proceed with the booking
        setIsModalOpen(false);
        goToBookingSummary(updatedLockers);
    };

    const handleBulkConfirmSlot = ({ slot, durationInMilliseconds }) => {
        setBulkSelectedDuration(durationInMilliseconds);

        const updated = selectedLockers.map((locker) => {
            const matchedSlot = locker?.bookingSlots?.find(
                (s) => s.durationInMilliseconds === durationInMilliseconds
            );

            return {
                ...locker,
                selectedSlot: matchedSlot || null,
            };
        });

        setSelectedLockers(updated);
        setShowBulkSlotModal(false);
        goToBookingSummary(updated);
    };

     const convertToInch = (w, d, h) => {
    if (!w || !d || !h) return "";
    return `${toFeetInches(w)} W x ${toFeetInches(d)} D x ${toFeetInches(h)} H`;
  };

    return (
        <Box className='locker-size-page'>
            <div className="main-container-temp">
            <div className="main">
                {availableLockerSizes?.length > 0 ? (
                    <>
                    {availableLockerSizes.map((locker) => {
                        
                        const price24h = IsAdvanceBooking ? getPriceFor24Hr(locker.size_pricing) : null;
                        return (
                            <div key={locker.id} className="locker-card">
                                <div className="lokcer-image-container">
                                    <img alt="locker" src={LockerIcon} />
                                </div>

                                <div className="locker-sizes-container">
                                    <div className="locker-dimentaion-container">
                                    <h3>{t('locker_size_code_locker', { code: locker.code })}</h3>
                                    <span>
                                         {convertToInch(
                                            locker?.width,
                                            locker?.depth,
                                            locker?.height
                                            )}
                                    </span>
                                    </div>
                                        {  isPricingEnabled &&
                                    <h4>{t('lockers_available_text', { count: locker?.available_doors_count })}</h4> }
                                </div>
                                { isPricingEnabled ?
                                <div className="locker-price-button-container">
                                    <h1 className="locker-price">
                                        {
                                        IsAdvanceBooking &&
                                        // this is for advacne booking format 
                                       
                                        (price24h !== null ? `${getCurrencySymbol(lockerCurrency)} ${(price24h)} Per Day ` : '')
                                        }
                                
                                    </h1>
                                    <div className="lokcer-button-container">
                                        {/* <ButtonComponent
                                            type="cycle-type"
                                            handleClick={() => decreaseQty(locker)}
                                            title={"-"} /> */}
                                    <button onClick={() => decreaseQty(locker)}>-</button>
                                    <span>
                                        {
                                        selectedLockers.filter(
                                            (item) => item.door_size === locker.code
                                        ).length
                                        }
                                    </span>
                                    <button
                                        onClick={() => increaseQty(locker,price24h)}
                                        disabled={
                                        selectedLockers.filter(
                                            (item) => item.door_size === locker.code
                                        ).length >= locker.available_doors_count
                                        }
                                    >
                                        +
                                    </button>
                                    </div>
                                </div>
                                :
                                <div>
                                    <ButtonComponent type="primary" handleClick={()=> lockerSizeClickHandler(locker)} title={"book_lockers_button"}/>
                                </div>
                                }
                            </div>
                        );
                    })}

                    {/* Bottom Summary */}
                    { isPricingEnabled &&
                        <div className="bottom-container-button">
                            {IsAdvanceBooking &&(
                                <div className="summary-amount-container">
                                    <h1>{t('total_label')}</h1>
                                    <h1>{`${lockerCurrency} ${totalPrice}`}</h1>
                                </div>
                            )}
                            <ButtonComponent
                                title={"book_lockers_button"}
                                handleClick={handleSelectedLokcerObject}
                                disabled={selectedLockers.length === 0}
                            />
                        </div>
                    }
                    </>
                ) : (
                    <p>{t('no_locker_here_text')}</p>
                )}
            </div>
            <div>
        </div>
            </div>
            {showBulkSlotModal && selectedLockers?.length > 0 && (
                <LockerModalContent
                    lockerCurrency={lockerCurrency != 'null' ? lockerCurrency : selectedLockers[0]?.currency}
                    lockerInfos={selectedLockers[0]}
                    selectedDuration={bulkSelectedDuration}
                    onConfirm={handleBulkConfirmSlot}
                    onCancel={() => setShowBulkSlotModal(false)}
                />
            )}
            
       
        </Box>
    )
}

export default LockerSizePage;
